module.exports = __webpack_public_path__ + "414256dafd46dd48c4d332f6b6c7db16.jpg";